import apiClient from './apiClient';

export const werkzeugApi = {
  getAll: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.zustand) query.set('zustand', params.zustand);
    if (params.kategorie) query.set('kategorie', params.kategorie);
    const qs = query.toString();
    const response = await apiClient.get(`/werkzeuge${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/werkzeuge', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/werkzeuge/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/werkzeuge/${id}`);
    return response.data;
  }
};

export default werkzeugApi;
